<template>
  <div class="body">
    <div id="game"></div>
    <h1 class="score">分数：{{ score }}</h1>
    <van-popup v-model="showStart" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo" v-html="name"></h1>
        <br />
        <van-tag v-if="play_times_free>play_times_today" type="success" size="large">今日免费次数： {{play_times_today}} / {{play_times_free}}</van-tag>
        <br /><br />
        <ul v-if="gameConf">
          <li v-if="play_times_free<=play_times_today">{{ price }} 金豆游戏一次</li>
          <li>成功投掷一把飞刀 分数 +{{ gameConf.knifeAdd }}</li>
          <li>飞刀击中苹果 分数 +{{ gameConf.appleAdd }}</li>
          <li>飞刀碰撞，游戏结束</li>
          <li>结束后, 所有分数结算为金豆</li>
        </ul>
        <br />
        <h1>当前金豆: {{ user_score }}</h1>
        <br /><br />
        <van-button
          type="danger"
          plain
          @click="gameStart()"
          :loading="progress < 1"
          :loading-text="parseInt(progress * 100) + ' %'"
          :disabled ="play_times_today>=play_times_max"
        >
          开始游戏 {{play_times_today}}/{{play_times_max}}
        </van-button>
        <br /><br />
        <!-- <van-button type="info" plain @click="quit()"> 退出 </van-button> -->
      </div>
    </van-popup>
    <van-popup v-model="showEndTip" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <br /><br /><br />
        <h1 class="logo">游戏结束</h1>
        <br /><br /><br />
        <h2>结算中,请稍后...</h2>
      </div>
    </van-popup>
    <van-popup v-model="showEnd" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo" v-html="name"></h1>
        <br /><br /><br />
        <div class="endInfo">
          <br />
        <van-tag v-if="play_times_free>play_times_today" type="success" size="large">今日免费次数： {{play_times_today}} / {{play_times_free}}</van-tag>
        <br /><br />
          <h2>获得金豆: {{ score }}</h2>
        </div>

        <br />
        <h1>当前金豆: {{ user_score }}</h1>
        <br /><br />
        <van-button type="danger" plain @click="gameStart()"
          :disabled ="play_times_today>=play_times_max"
          >重新开始 {{play_times_today}}/{{play_times_max}}</van-button
        >
        <br /><br />
        <van-button
          type="primary"
          plain
          @click="
            showEnd = false;
            showStart = true;
          "
          >查看规则</van-button
        >
        <br /><br />
        <!-- <van-button type="info" plain @click="quit()">退出</van-button> -->
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
.panel {
  padding: 2rem 0.5rem;
  /* background-color:white; */
  text-align: center;
}
.van-popup {
  background-color: #00000000;
  color: white;
}
.panel .logo {
  font-size: 0.8rem;
  color: tomato;
}
.score {
  font-size: 0.5rem;
  color: #ffffff;
  position: fixed;
  top: 65px;
  right: 30px;
}
.body {
  background-image: url(http://game.hdmingpinmall.cn/games/game5/bg.jpg);
  height: 100%;
}
</style>
<script>
import Vue from "vue";
import { Popup } from "vant";
import { Button } from "vant";
//Toast
import { Toast } from "vant";
import { Col, Row } from "vant";

Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Popup);

import { Tag } from 'vant';
Vue.use(Tag);

import { VUE_GAME_ASSETS_URL } from "@utils";
import { getUserInfo,getUserInfo_game } from "@api/user";
import { game11_config, game11_start, game11_end } from "@api/game";

// import { playGame } from "@utils/games/game11_tyt";
import Phaser from "phaser";
export default {
  name: "Game11_fd",
  data() {
    return {
      name: "飞刀",
      user_id: 0,
      user_score: 0,
      log_id: 0,
      showStart: true,
      showEnd: false,
      showEndTip: false,
      gameMode: IDLE,

      price: 0,
      gameConf: null,
      play_times_today:10,
      play_times_max:10,
      play_times_free:0,
      score: 0,
    };
  },
  mounted: function () {
    this.user_id=this.getQueryVariable('uid')
    vm = this;
    let that = this;
    // getUserInfo_game(this.user_id).then(res => {
      game11_config({ user_id: that.user_id }).then((res) => {
        console.log(res);
        that.user_score = parseFloat(res.data.user_score);
        that.price = res.data.price;
        that.gameConf = res.data.gameConf;
        that.play_times_today = res.data.play_times_today;
        that.play_times_free = res.data.play_times_free?res.data.play_times_free:0;
      });
    // });
    onload();
  },
  methods: {
    getQueryVariable(variable)
    {
          var query = window.location.href.substring(window.location.href.indexOf('?')+1);
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
                  var pair = vars[i].split("=");
                  if(pair[0] == variable){return pair[1];}
          }
          return(false);
    },
    gameStart() {
      if (this.play_times_free<=this.play_times_today && this.user_score<this.price) {
        Toast.fail('金豆不足');
        return;
      }
      let that = this;
      game11_start({ user_id: that.user_id })
        .then((res) => {
          console.log(res);
          // that.user_score -= that.price;
          that.showStart = false;
          that.showEnd = false;
          that.user_score = parseFloat(res.data.game_money);
          that.log_id = res.data.log_id;
          that.score = 0;
          that.play_times_today++;
        })
        .catch((err) => {
          Toast.fail(err.msg);
        });
    },
    gameEnd() {
      let that = this;
      that.showEndTip = true;
      setTimeout(function () {
        that.showEnd = true;
        that.showEndTip = false;
        game11_end({
          user_id: that.user_id,
          score: that.score,
          log_id: that.log_id,
        }).then(() => {});
        that.user_score += that.score;
      }, 1000);
    },
    addScore(flag) {
      switch (flag) {
        case "apple":
          this.score += this.gameConf.appleAdd;
          break;
        case "knife":
          this.score += this.gameConf.knifeAdd;
          break;
      }
    },
    quit() {
      this.$router.push({ path: "/user" });
    },
  },
  beforeDestroy: function () {
    if (game) {
      game.destroy();
    }
    let canvas = document.getElementsByTagName("canvas");
    if (canvas[0]) canvas[0].remove();
  },
};
let vm;
let game;
let bgm;
const IDLE = 0; //空闲

// global game options
var gameOptions = {
  // target rotation speed, in degrees per frame
  rotationSpeed: 3,

  // knife throwing duration, in milliseconds
  throwSpeed: 150,

  // minimum angle between two knives
  minAngle: 15,

  // max rotation speed variation, in degrees per frame
  rotationVariation: 2,

  // interval before next rotation speed variation, in milliseconds
  changeTime: 2000,

  // maximum rotation speed, in degrees per frame
  maxRotationSpeed: 6,
};

// once the window loads...
let onload = function () {
  // game configuration object
  var gameConfig = {
    // render type
    type: Phaser.CANVAS,

    // game width, in pixels
    width: 750,

    // game height, in pixels
    height: 1334,

    // game background color
    //    backgroundColor: 0x444444,

    // scenes used by the game
    scene: [playGame],
    transparent: true,
    parent: "game",
  };

  // game constructor
  game = new Phaser.Game(gameConfig);

  // pure javascript to give focus to the page/frame and scale the game
  window.focus();
  resize();
  window.addEventListener("resize", resize, false);
};

// PlayGame scene
class playGame extends Phaser.Scene {
  // constructor
  constructor() {
    super("PlayGame");
  }

  // method to be executed when the scene preloads
  preload() {
    this.load.setBaseURL(VUE_GAME_ASSETS_URL);
    // loading assets
    this.load.image("target", "games/game5/target.png");
    this.load.image("knife", "games/game5/knife.png");
    this.load.spritesheet("apple", "games/game5/apple.png", {
      frameWidth: 70,
      frameHeight: 96,
    });

    this.load.audio("feidao", "games/game5/feidao1.mp3");
    this.load.audio("pz", "games/game5/pz1.mp3");
    this.load.audio("bg", "games/xiaoxiaole/bgm2.mp3");
  }

  // method to be executed once the scene has been created
  create() {
    if (!bgm) {
      bgm = this.sound.add("bg");
      bgm.addMarker({
        name: "loop",
        config: {
          loop: true,
        },
      });
      bgm.play("loop");
    }

    // at the beginning of the game, both current rotation speed and new rotation speed are set to default rotation speed
    this.currentRotationSpeed = gameOptions.rotationSpeed;
    this.newRotationSpeed = gameOptions.rotationSpeed;

    // can the player throw a knife? Yes, at the beginning of the game
    this.canThrow = true;

    // group to store all rotating knives
    this.knifeGroup = this.add.group();

    // adding the knife
    this.knife = this.add.sprite(
      game.config.width / 2,
      (game.config.height / 5) * 4,
      "knife"
    );

    // adding the target
    this.target = this.add.sprite(game.config.width / 2, 400, "target");

    // moving the target to front
    this.target.depth = 1;

    // starting apple angle
    var appleAngle = Phaser.Math.Between(0, 360);

    // determing apple angle in radians
    var radians = Phaser.Math.DegToRad(appleAngle - 90);

    // adding the apple
    this.apple = this.add.sprite(
      this.target.x + (this.target.width / 2) * Math.cos(radians),
      this.target.y + (this.target.width / 2) * Math.sin(radians),
      "apple"
    );

    // setting apple's anchor point to bottom center
    this.apple.setOrigin(0.5, 1);

    // setting apple sprite angle
    this.apple.angle = appleAngle;

    // saving apple start angle
    this.apple.startAngle = appleAngle;

    // apple depth is the same as target depth
    this.apple.depth = 1;

    // has the apple been hit?
    this.apple.hit = false;

    // waiting for player input to throw a knife
    this.input.on("pointerdown", this.throwKnife, this);

    // this is how we create a looped timer event
    var timedEvent = this.time.addEvent({
      delay: gameOptions.changeTime,
      callback: this.changeSpeed,
      callbackScope: this,
      loop: true,
    });
  }

  // method to change the rotation speed of the target
  changeSpeed() {
    // ternary operator to choose from +1 and -1
    var sign = Phaser.Math.Between(0, 1) == 0 ? -1 : 1;

    // random number between -gameOptions.rotationVariation and gameOptions.rotationVariation
    var variation = Phaser.Math.FloatBetween(
      -gameOptions.rotationVariation,
      gameOptions.rotationVariation
    );

    // new rotation speed
    this.newRotationSpeed = (this.currentRotationSpeed + variation) * sign;

    // setting new rotation speed limits
    this.newRotationSpeed = Phaser.Math.Clamp(
      this.newRotationSpeed,
      -gameOptions.maxRotationSpeed,
      gameOptions.maxRotationSpeed
    );
  }

  // method to throw a knife
  throwKnife() {
    // can the player throw?
    if (this.canThrow) {
      // player can't throw anymore
      this.canThrow = false;

      // tween to throw the knife
      this.tweens.add({
        // adding the knife to tween targets
        targets: [this.knife],

        // y destination
        y: this.target.y + this.target.width / 2,

        // tween duration
        duration: gameOptions.throwSpeed,

        // callback scope
        callbackScope: this,

        // function to be executed once the tween has been completed
        onComplete: function (tween) {
          // at the moment, this is a legal hit
          var legalHit = true;

          // getting an array with all rotating knives
          var children = this.knifeGroup.getChildren();

          // looping through rotating knives
          for (var i = 0; i < children.length; i++) {
            // is the knife too close to the i-th knife?
            if (
              Math.abs(
                Phaser.Math.Angle.ShortestBetween(
                  this.target.angle,
                  children[i].impactAngle
                )
              ) < gameOptions.minAngle
            ) {
              // this is not a legal hit
              legalHit = false;

              // no need to continue with the loop
              break;
            }
          }

          // is this a legal hit?
          if (legalHit) {
            // is the knife close enough to the apple? And the appls is still to be hit?
            if (
              Math.abs(
                Phaser.Math.Angle.ShortestBetween(
                  this.target.angle,
                  180 - this.apple.startAngle
                )
              ) < gameOptions.minAngle &&
              !this.apple.hit
            ) {
              // apple has been hit
              this.apple.hit = true;

              // change apple frame to show one slice
              this.apple.setFrame(1);

              // add the other apple slice in the same apple posiiton
              var slice = this.add.sprite(
                this.apple.x,
                this.apple.y,
                "apple",
                2
              );

              // same angle too.
              slice.angle = this.apple.angle;

              // and same origin
              slice.setOrigin(0.5, 1);

              // tween to make apple slices fall down
              this.tweens.add({
                // adding the knife to tween targets
                targets: [this.apple, slice],

                // y destination
                y: game.config.height + this.apple.height,

                // x destination
                x: {
                  // running a function to get different x ends for each slice according to frame number
                  getEnd: function (target, key, value) {
                    return (
                      Phaser.Math.Between(0, game.config.width / 2) +
                      (game.config.width / 2) * (target.frame.name - 1)
                    );
                  },
                },

                // rotation destination, in radians
                angle: 45,

                // tween duration
                duration: gameOptions.throwSpeed * 6,

                // callback scope
                callbackScope: this,

                // function to be executed once the tween has been completed
                onComplete: function (tween) {
                  console.log("击中苹果");
                  vm.addScore("apple");
                  // restart the game  重置游戏
                  // this.scene.start("PlayGame")
                },
              });
            }

            // player can now throw again
            this.canThrow = true;

            // adding the rotating knife in the same place of the knife just landed on target
            var knife = this.add.sprite(this.knife.x, this.knife.y, "knife");

            // impactAngle property saves the target angle when the knife hits the target
            knife.impactAngle = this.target.angle;

            // adding the rotating knife to knifeGroup group
            this.knifeGroup.add(knife);

            // bringing back the knife to its starting position
            this.knife.y = (game.config.height / 5) * 4;
            this.sound.add("feidao").play();
            console.log("投掷成功");
            vm.addScore("knife");
          }

          // in case this is not a legal hit
          else {
            this.sound.add("pz").play();
            console.log("碰撞");
            // tween to make the knife fall down
            this.tweens.add({
              // adding the knife to tween targets
              targets: [this.knife],

              // y destination
              y: game.config.height + this.knife.height,

              // rotation destination, in radians
              rotation: 5,

              // tween duration
              duration: gameOptions.throwSpeed * 4,

              // callback scope
              callbackScope: this,

              // function to be executed once the tween has been completed
              onComplete: function (tween) {
                
                console.log("碰撞动画完成");
                // restart the game
                vm.gameEnd();
                this.scene.start("PlayGame");
              },
            });
          }
        },
      });
    }
  }

  // method to be executed at each frame. Please notice the arguments.
  update(time, delta) {
    // rotating the target
    this.target.angle += this.currentRotationSpeed;

    // getting an array with all rotating knives
    var children = this.knifeGroup.getChildren();

    // looping through rotating knives
    for (var i = 0; i < children.length; i++) {
      // rotating the knife
      children[i].angle += this.currentRotationSpeed;

      // turning knife angle in radians
      var radians = Phaser.Math.DegToRad(children[i].angle + 90);

      // trigonometry to make the knife rotate around target center
      children[i].x =
        this.target.x + (this.target.width / 2) * Math.cos(radians);
      children[i].y =
        this.target.y + (this.target.width / 2) * Math.sin(radians);
    }

    // if the apple has not been hit...
    if (!this.apple.hit) {
      // adjusting apple rotation
      this.apple.angle += this.currentRotationSpeed;

      // turning apple angle in radians
      var radians = Phaser.Math.DegToRad(this.apple.angle - 90);

      // adjusting apple position
      this.apple.x =
        this.target.x + (this.target.width / 2) * Math.cos(radians);
      this.apple.y =
        this.target.y + (this.target.width / 2) * Math.sin(radians);
    }

    // adjusting current rotation speed using linear interpolation
    this.currentRotationSpeed = Phaser.Math.Linear(
      this.currentRotationSpeed,
      this.newRotationSpeed,
      delta / 1000
    );
  }
}

// pure javascript to scale the game
function resize() {
  var canvas = document.querySelector("canvas");
  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;
  var windowRatio = windowWidth / windowHeight;
  var gameRatio = game.config.width / game.config.height;
  if (windowRatio < gameRatio) {
    canvas.style.width = windowWidth + "px";
    canvas.style.height = windowWidth / gameRatio + "px";
  } else {
    canvas.style.width = windowHeight * gameRatio + "px";
    canvas.style.height = windowHeight + "px";
  }
}
</script>

